// import external dependencies
import 'jquery';
import 'objectFitPolyfill';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset.min';
import 'lazysizes/plugins/respimg/ls.respimg.min';
import 'lazysizes/plugins/attrchange/ls.attrchange.min';

// Import everything from autoload
import './autoload/_foundation.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateLocation from './routes/templateLocation';
import templateInfo from './routes/templateInfo';
import templateDeveloper from './routes/templateDeveloper';
import templateInteriordesign from './routes/templateInteriordesign';
import templateGallery from './routes/templateGallery';
import templateBusinessplan from './routes/templateBusinessplan';
import templatePlan from './routes/templatePlan';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Location page
  templateLocation,
  // Info page
  templateInfo,
  // Developer page
  templateDeveloper,
  // Interior design page
  templateInteriordesign,
  // Businesses plan page
  templateBusinessplan,
  // Businessgallery page
  templateGallery,
  // Plan page
  templatePlan,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js